module.exports = __webpack_public_path__ + "img/WEX_cahora.579a6e1e.jpg";